import { v4 as uuidv4 } from "uuid";
import { NotebookPage } from "./note";

export interface Protocol {
  type: "omega/query-omega/protocol/Protocol";
  name: string;
  "app-id": string;
  "page-id": string;
  "protocol-id": string;
  spec: string;
}

export const installProtocolSpec: ProtocolSpec = {
  functions: [
    {
      type: "function",
      args: [{ type: "self" }],
      name: "install",
    },
  ],
};

export const installProtocolSpecJson = JSON.stringify(
  installProtocolSpec,
  null,
  4
);

export const installProtocol: Protocol = {
  name: "Install",
  "app-id": "built-in-app",
  "page-id": "built-in-page",
  "protocol-id": "omega/query-omega/protocol/install/InstallProtocol",
  type: "omega/query-omega/protocol/Protocol",
  spec: installProtocolSpecJson,
};

export const newProtocol = (config: { name: string; page: NotebookPage }) => {
  const { name, page } = config;
  const comp: Protocol = {
    type: "omega/query-omega/protocol/Protocol",
    name,
    "app-id": page["app-id"],
    "page-id": page["page-id"],
    "protocol-id": uuidv4(),
    spec: "{}",
  };
  return comp;
};

export type ProtocolMap = { [k: string]: Protocol };

export const initProtocolMap = {
  [installProtocol["protocol-id"]]: installProtocol,
};

export interface ProtocolFunctionSpec {
  type: "function";
  name: string;
  args: any[];
}

export interface ProtocolSpec {
  functions: ProtocolFunctionSpec[];
}

export type UseProtocolSearchProps = {
  searchString: string;
  setSearchString: (searchString: string) => void;
  page: Protocol[];
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
};
